import * as yup from "yup";

export const SalaryProfileValidationSchema = yup.object({
  // employee: yup.string().required("Employee is required"),
  profileAppliesFromPayPeriod: yup
    .string()
    .required("Profile applies from Pay Period is required"),
  regularHours: yup
    .string()
    .required("Regular Hours is required"),
});
